import React from 'react';
import Separator from "./Separator/separator";
import './Convenios.css';
import portoSeguro from '../assets/planos/porto-seguro.png';
import amil from '../assets/planos/amil.png';
import plena from '../assets/planos/plena.png';
import prodental from '../assets/planos/prodental.png';

const Convenios = () => {
    const convenios = [
        {
            nome: 'Porto Seguro',
            logo: portoSeguro
        },
        {
            nome: 'Amil',
            logo: amil
        },
        {
            nome: 'Plena Saúde',
            logo: plena
        },
        {
            nome: 'Prodental Brasil',
            logo: prodental
        }
    ];

    return (
        <section className="convenios-section">
            <div className="container">
                <div className="tit-sections mt-50">
                    <h1>Planos odontológicos</h1>
                    <Separator />
                    <h2>"Trabalhamos com os seguintes planos odontológicos, entre em contato conosco para mais informações"</h2>
                    <p>Porto Seguro | Amil | Plena Saúde | Prodental Brasil</p>
                </div>
                <div className="convenios-grid">
                    {convenios.map((convenio, index) => (
                        <div key={index} className="convenio-card">
                            <img 
                                src={convenio.logo} 
                                alt={`Logo ${convenio.nome}`}
                                className="convenio-logo"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Convenios; 